import { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

function LanguageSelector() {
  const { language, setLanguage, translations } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleLanguageSelect = (lang) => {
    setLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        className="bg-transparent border-none cursor-pointer w-12 sm:w-[60px] p-0 flex items-center justify-center"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={translations.labels.languageSelection}
      >
        <img src="/images/lang.svg" alt={translations.labels.languageSelection} className="w-full h-auto" width="60" height="46" />
      </button>

      {isOpen && (
        <div className="flex flex-col gap-2.5 absolute top-[calc(100%+12px)] right-0 bg-brown-primary rounded-xl px-2 py-2.5 min-w-[160px] sm:min-w-[200px] max-w-[calc(100vw-2rem)] shadow-lg z-[1000] overflow-hidden">
          <button
            className={`w-full py-2 px-3 cursor-pointer text-xl text-left transition-all duration-200 rounded-lg ${language === 'en'
              ? 'bg-beige-light text-brown-primary'
              : 'bg-white/10 text-white hover:bg-beige-light/20'
              }`}
            onClick={() => handleLanguageSelect('en')}>English</button>
          <button
            className={`w-full py-2 px-3 cursor-pointer text-xl text-left transition-all duration-200 rounded-lg ${language === 'mr'
              ? 'bg-beige-light text-brown-primary'
              : 'bg-white/10 text-white hover:bg-beige-light/20'
              }`}
            onClick={() => handleLanguageSelect('mr')}>मराठी</button>
          <button
            className={`w-full py-2 px-3 cursor-pointer text-xl text-left transition-all duration-200 rounded-lg ${language === 'hi'
              ? 'bg-beige-light text-brown-primary'
              : 'bg-white/10 text-white hover:bg-beige-light/20'
              }`}
            onClick={() => handleLanguageSelect('hi')}>हिंदी</button>
            
        </div>
      )}
    </div>
  );
}

export default LanguageSelector;

